<script lang="ts">
	// TODO: Replace usage of this component with the "slidein" action...

	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLElement> {
		duration?: number;
		delay?: number;
		as?: string;
		wrapperType?: string;
		threshold?: number;
		rootMargin?: string;
		replay?: boolean;
		contentClass?: string;
		onintroend?: () => void;
		onintrostart?: () => void;
	}
	let {
		duration = 1000,

		delay = 0,
		as = 'div',
		wrapperType = 'div',
		threshold = 0.05,
		rootMargin = '0px 0px 0px 0px',
		replay = false,
		contentClass = '',
		children,
		onintroend,
		onintrostart,
		...other
	}: Props = $props();

	let container = $state<HTMLElement>();

	const CONTAINER_FALLBACK_HEIGHT = 500;

	let containerHeight = $state(CONTAINER_FALLBACK_HEIGHT);
	let visible = $state(false);

	$effect(() => {
		if (!container) return;

		const observer = new IntersectionObserver(
			(entries, observer) => {
				const entry = entries[0];

				visible = entry.isIntersecting;

				if (visible && !replay) {
					observer.disconnect();
				}
			},
			{ threshold, rootMargin }
		);

		observer.observe(container);

		return () => observer.disconnect();
	});

	$effect(() => {
		if (visible && container && container.parentElement) {
			containerHeight = container.parentElement.clientHeight;
		}
	});

	let startPosition = $derived(containerHeight * 0.25);
</script>

<svelte:element this={wrapperType} bind:this={container} {...other}>
	<svelte:element
		this={as}
		class="h-full w-full {contentClass} {visible ? '' : 'opacity-[0.01]'}"
		style="transform: translate3d(0, {visible
			? 0
			: startPosition}px, 0); transition-property: transform, opacity; transition-duration: {duration}ms; transition-delay: {delay}ms; transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1)"
		ontransitionstart={(e) => {
			if (e.propertyName !== 'transform') return;
			onintrostart?.();
		}}
		ontransitionend={(e) => {
			if (e.propertyName !== 'transform') return;
			onintroend?.();
		}}
	>
		{@render children?.()}
	</svelte:element>
</svelte:element>
